<template>
  <div>
    <div @keyup.enter="onClickQueryBtn()">
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        size="mini"
        style="margin-top: 30px"
      >
        <el-form-item label="查询方式：">
          <el-radio-group v-model="form.queryType">
            <el-radio label="">全部</el-radio>
            <el-radio label="text">按内容</el-radio>
            <el-radio label="uid">按UID</el-radio>
            <el-radio label="aid">按AID</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.queryType != ''"
          :label="getInputLabelByQueryType(form.queryType)"
        >
          <el-input
            v-model="form.queryValue"
            clearable
            style="width: 172px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="onClickQueryBtn()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="chatHistoryListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="chatHistoryListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 1281px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="140" />
      <el-table-column prop="text" label="内容" align="center" width="300" />
      <el-table-column
        prop="chatChannelTypeDesc"
        label="频道类型"
        align="center"
        width="80"
      />
      <el-table-column
        prop="chatChannel"
        label="频道标识"
        align="center"
        width="100"
      />
      <el-table-column prop="name" label="昵称" align="center" width="120" />
      <el-table-column label="UID" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.uid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'uid')"
            >
              {{ scope.row.uid }}</a
            >{{ getChanBanDesc("uid", scope.row.status) }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="AID" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.aid > 0">
            <a
              href="javascript:;"
              style="text-decoration: none"
              @click="toRouterPlayerInfoPage(scope.row, 'aid')"
            >
              {{ scope.row.aid }}</a
            >{{ getChanBanDesc("aid", scope.row.status) }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="thirdPartyId"
        label="第三方账号ID"
        align="center"
        width="120"
        show-overflow-tooltip
      />

      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            style="padding: 3px 10px"
            @click="onClickDeleteChatMessageBtn(scope.row.id)"
            >删除</el-button
          >
          <span style="margin-right: 10px"></span>
          <el-dropdown trigger="click" @command="onClickChatBanBtn">
            <el-button
              :disabled="scope.row.status == 3"
              size="mini"
              style="padding: 3px 10px"
              type="primary"
            >
              禁言<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="scope.row.status == 1"
                :command="{ condition: 'uid', value: scope.row.uid }"
                ><span>UID禁言</span></el-dropdown-item
              >
              <el-dropdown-item
                :disabled="scope.row.status == 2"
                :command="{ condition: 'aid', value: scope.row.aid }"
                ><span>AID禁言</span></el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      chatHistoryListTableData: [],
      form: {
        queryType: "",
        queryValue: "",
      },
    };
  },

  methods: {
    getInputLabelByQueryType(qt) {
      switch (qt) {
        case "uid":
          return "UID：";
        case "aid":
          return "AID：";
        case "text":
          return "包含内容：";
        default:
          return "";
      }
    },

    loadMore() {
      this.loadChatHistoryList(this.chatHistoryListTableData.length, 20);
    },

    /**
     * 跳转到玩家详情界面
     * @param {*} entry
     */
    toRouterPlayerInfoPage(entry, condition) {
      var query = {};
      switch (condition) {
        case "uid": {
          query = { uid: entry.uid, tab: "playerList" };
          break;
        }
        case "aid": {
          query = { aid: entry.aid, tab: "playerList" };
          break;
        }
      }

      window.open(
        this.$router.resolve({
          path: "/console/player/playerlist",
          query: query,
        }).href,
        "_blank"
      );
    },

    /**
     * 查询聊天历史列表
     */
    async loadChatHistoryList(skip, limit) {
      // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
      if (skip == 0) {
        this.chatHistoryListTableData = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryChatHistoryList`,
          {
            byType: this.form.queryType,
            byValue: this.form.queryValue,
            skip: skip,
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let listInResp = resData.data.entries || [];

      let list = [];
      for (let e of listInResp) {
        list.push({
          id: e.id,
          uid: e.uid,
          name: e.name,
          aid: e.aid,
          thirdPartyId: e.thirdPartyId,
          when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
          chatChannelTypeDesc: e.chatChannelTypeDesc,
          chatChannel: e.chatChannel,
          text: e.text,
          status: e.status,
        });
      }

      this.chatHistoryListTableData =
        this.chatHistoryListTableData.concat(list);
    },

    /**
     * 返回禁言描述
     */
    getChanBanDesc(condition, status) {
      let desc = "";
      if (condition == "uid") {
        if (status == 1 || status == 3) {
          desc = "(已禁言)";
        }
      }
      if (condition == "aid") {
        if (status == 2 || status == 3) {
          desc = "(已禁言)";
        }
      }

      return desc;
    },
    /**
     * 改变禁言状态(为禁言后改变内存中玩家的状态)
     */
    changeStatusAfterChanBan(condition, status) {
      let newStatus = status;
      if (condition == "uid") {
        if (status == 0) {
          newStatus = 1;
        }
        if (status == 2) {
          newStatus = 3;
        }
      }
      if (condition == "aid") {
        if (status == 0) {
          newStatus = 2;
        }
        if (status == 1) {
          newStatus = 3;
        }
      }

      return newStatus;
    },
    /**
     * 点击了禁言按钮
     */
    async onClickChatBanBtn(obj) {
      let condition = obj.condition;
      let value = obj.value;
      try {
        // 弹确认框
        await this.$confirm(
          `确认禁言${
            condition == "aid" ? "AID: " + value : "UID: " + value
          }的玩家？`
        );
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/addChatBan`,
            {
              byType: condition,
              byValue: value + "",
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "禁言成功",
          type: "success",
        });

        // 刷新禁言状态
        for (let entry of this.chatHistoryListTableData) {
          switch (condition) {
            case "uid": {
              if (entry.uid == value) {
                entry.status = this.changeStatusAfterChanBan(
                  condition,
                  entry.status
                );
              }
              break;
            }
            case "aid": {
              if (entry.aid == value) {
                entry.status = this.changeStatusAfterChanBan(
                  condition,
                  entry.status
                );
              }
              break;
            }
          }
        }
      } catch (e) {}
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadChatHistoryList(0, 20);
    },

    /**
     * 点击了聊天消息的删除按钮
     * @param {*} entryId
     */
    onClickDeleteChatMessageBtn(entryId) {
      this.$confirm("确认删除该条聊天记录？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteChatMessage(entryId);
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 删除一条聊天消息
     */
    async deleteChatMessage(entryId) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/deleteHistoryChatMessages`,
          {
            id: entryId,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        type: "success",
        message: "删除成功!",
      });

      for (let i = 0; i < this.chatHistoryListTableData.length; i++) {
        if (this.chatHistoryListTableData[i].id == entryId) {
          this.chatHistoryListTableData.splice(i);
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>
